import { faMapMarked } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import ContactCta from "../../Components/ContactCta";
import { FaCalendarAlt, FaTachometerAlt, FaGasPump, FaCogs, FaBolt, FaCheckCircle, FaSellsy, FaTag } from "react-icons/fa";
import { MACHINERY, PARTS, SERVICES } from "../../constants";
import { PREV_IMG } from "../../constants/endPoints";
import { convertNumber, convertToBase64, createItemUrl, currencyFormat, hasPrice, hasYear, machineTypeLabel, optText } from "../../constants/helper";

const ProductItem = ({ val, index, type, loc, ...props }) => {
    const provinceName = optText((loc && loc.name) || (val.item_location && val.item_location.name));
    const manuName = optText(val.manufacturer_id == -1 ? val.manufacturer_name : (val.manufacturer && val.manufacturer.name));
    const modelName = optText(val.model_id == -1 ? val.model_name : (val.model && val.model.name));
    const year = hasYear(val.year) ? val.year : '';
    const isParts = val.category_id == PARTS;
    const isServices = val.category_id == SERVICES;
    const machineType = val.category_id == MACHINERY ? machineTypeLabel(val.item_type) : '';
    const vehicleBrand = optText(val.vehicle_brand && val.vehicle_brand.name);
    const ownTitle = isParts && val.title;
    const vehicleTitle = [manuName, modelName, year].filter(Boolean).join(' ');
    return <div className="product-item special col-lg-3 col-md-4" key={index + type}>
        <Link to={() => {
            return "/product_details/" + convertToBase64(val.id) + createItemUrl(val);
        }} className="special-link" style={{ position: "relative" }}>
            <div className="product-image">
                <img className="logo-image" src="/external_assets/img/motor_logo.png" width={80} height={40} />
                <p className="special-img">
                    <img className="home-item-img" src={PREV_IMG + val.default_photo.img_path} alt={(manuName && !ownTitle)
                        ? vehicleTitle
                        : val.title} onError={(e) => { e.target.src = "./assets/images/placeholder.jpeg" }} />
                </p>
            </div>
            {/*  */}
            {
                manuName && !ownTitle &&
                <h3><span className="title">{vehicleTitle}</span></h3>
            }
            {
                (!manuName || ownTitle) &&
                <h3><span className="title">{val.title}</span></h3>
            }
            {/*  */}
            <div className="row home-item-info">
                <div className="col-12">
                    <ul className="information ps-0">
                        {isServices && optText(val.service_area) && <li><span>Área de serviço: {val.service_area}</span></li>}
                        {isServices && provinceName && <li><span>Província: {provinceName}</span></li>}
                        {isParts && vehicleBrand && <li><span>Marca do veículo: {vehicleBrand}</span></li>}
                        {isParts && manuName && <li><span>Categoria: {manuName}</span></li>}
                        {isParts && modelName && <li><span>Sub Categoria: {modelName}</span></li>}
                        {machineType && <li><span><FaTag className="ic-rm4" />{machineType}</span></li>}
                        {year && <li><span><FaCalendarAlt className="ic-rm4" />{year} </span></li>}
                        {val.mileage && convertNumber(val.mileage) > 0 && <li><span><FaTachometerAlt className="ic-rm4" />{currencyFormat(val.mileage)} km</span></li>}
                        {val.fuel_type?.fuel_name && <li><span><FaGasPump className="ic-rm4" />{val.fuel_type.fuel_name}</span></li>}
                        {val.transmission?.name && <li><span><FaCogs className="ic-rm4" />{val.transmission.name}</span></li>}
                        {optText(val.engine_power) && <li><span><FaBolt className="ic-rm4" />{val.engine_power}</span></li>}
                        {val.condition_of_item?.name && <li><span><FaCheckCircle className="ic-rm4" />{val.condition_of_item.name}</span></li>}
                        {val.sell_type == "Rent" && <li><span><FaSellsy className="ic-rm4" />Aluguer</span></li>}
                    </ul>
                    {val.services && val.services.length > 0 &&
                        <ul className="service-tags ps-0">
                            {val.services.map((service, i) => (
                                <li className="service-tag" key={"service-tag-" + i}>{service.service_name}</li>
                            ))}
                        </ul>
                    }
                    {hasPrice(val.price) ? <section aria-label="Price" class="price-heading">
                        <div data-testid="ad-card-price" class="price heading-font">
                            <span>{currencyFormat(val.price)}</span><sup class="ooa-od9pi4 e4bdfv60">kz</sup>
                        </div>
                    </section> : <section aria-label="Contact" class="price-heading"><ContactCta item={val} compact /></section>}

                </div>
            </div>
        </Link>
    </div>;
}

export default ProductItem;
